import React, { Component } from 'react';
import ReactJson from 'react-json-view';

import { withStyles } from '@material-ui/core/styles';

import { Dialog } from 'sm-react-components';

const styles = (theme) => ({
    code: {
        padding: '10px',
        height: '70vh',
        overflowY: 'auto',
        textAlign: 'left'
    }
});

class ModalJson extends Component {
    render() {
        const { classes, open, data, title, onClose } = this.props;
        return (
            <Dialog open={open} title={title} onClose={onClose} showCancel={true} closeText={'Close'} modal>
                <div className={classes.code}>
                    <ReactJson
                        src={data}
                        collapsed={false}
                        enableClipboard={false}
                    />
                </div>
            </Dialog>
        );
    }
}

export default withStyles(styles)(ModalJson);